// header options
export const headerOptions = {
    MODULE_EDITOR_VIEW: 'Module View',
    VARIABLES: 'Variables',
    WORKFLOWS: 'Workflows',
    VERSIONS: 'Versions',
    PREVIEW: 'Preview',
    LOCALIZATION: 'Localization'
};
